import { Permission, PermissionsList, RPermissions } from '../types';

function getPermissions(permission: Permission[]) {
  return permission.reduce(
    (prev, curr) => [...prev, ...[curr]],
    [] as Permission[],
  );
}

export function constructPermissionListUtil(
  permissionList: PermissionsList,
): RPermissions {
  if (!Object.values(permissionList).length) {
    return {
      labels: {},
      permissions: [],
    };
  }
  const permissions: Permission[] = [];
  const labels: RPermissions['labels'] = {};
  for (const key of Object.keys(permissionList)) {
    if (!permissionList[key]) {
      continue;
    }
    permissions.push(...getPermissions(permissionList[key].permissions));
    Object.assign(labels, {
      [permissionList[key].label]: {
        description: permissionList[key].description,
      },
    });
  }
  return {
    labels,
    permissions,
  };
}
